// extracted by mini-css-extract-plugin
export default {"header":"Header_header__REZ3y","wrapper":"Header_wrapper__4Zvxq","logo":"Header_logo__Yhc57","title":"Header_title__GOOSP","change_theme":"Header_change_theme__aUSAE"};